import React, {useEffect, useRef, useState} from "react";
import './../Purchase.scss';
import './../PurchasePage.scss';
import {useHistory} from "react-router";
import PurchaseStatus from "../PurchaseStatus";
import Strings from "../../../../config/Strings";
import GlobalConstants from "../../../../config/GlobalConstants";
import {authCheck} from "../../../../util/authCheck";
import {Spinner} from "react-bootstrap";
import {ConfirmationModal, InfoModal} from "../../../../global/ConfirmationModal";
import {transformStringToReadableDate} from "../../../../util/ConverterUtil";
import * as billwerkJSWrapper from './../../../../api/BillwerkJSWrapper.js';
import {CreateResource, GetFilteredResources, GetResource, SendTeamsNotification} from "../../../../api/SpineClient";
import {TigerSpinner} from "../../../../global/tiger-spinner/TigerSpinner";
import gtmw from "../../../../api/GoogleTagManagerWrapper";
import {ResendActivationMail} from "../../../../global/resend-activation-mail/ResendActivationMail";

export default function SubscriptionPurchaseConfirmation() {

    const [priceData, setPriceData] = useState(null);
    const [trialInformation, setTrialInformation] = useState(null);
    const [hasTrial, setHasTrial] = useState(true);
    const [agb, setAgb] = useState(false);
    const [loading, setLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState(null);
    const [showLoginHint, setShowLoginHint] = useState(false);
    const [paymentError, setPaymentError] = useState(false);
    const [paymentErrorMessage, setPaymentErrorMessage] = useState(null);
    const [orderPreview, setOrderPreview] = useState(null);
    const [component, setComponent] = useState(null);
    const [discount, setDiscount] = useState(null);
    const [email, setEmail] = useState(null);
    const [purchaseData, setPurchaseData] = useState(null);
    const [firstPaymentDate, setFirstPaymentDate] = useState(null);
    const [feePeriodUnitName, setFeePeriodUnitName] = useState(null);
    const [premiumAccessFeature, setPremiumAccessFeature] = useState(null);
    const [nextPlanVariant, setNextPlanVariant] = useState(null);

    const history = useHistory();

    document.title = Strings.PURCHASE_SUBSCRIPTION_BROWSER_TAB;

    const dataRef  = useRef(null);

    useEffect(() => {
        const queryParams = new URLSearchParams(window.location.search);
        let email = JSON.parse(sessionStorage.getItem('email'));
        setEmail(email);
        let purchaseData = JSON.parse(sessionStorage.getItem('ls.purchase')) != null ?
            JSON.parse(sessionStorage.getItem('ls.purchase')) : {payment: {channelSecrets: {}}, contact: {}};
        setPurchaseData(purchaseData);

        if (purchaseData == null && queryParams.get("paymentFinished") !== "1") {
            history.push("/" + GlobalConstants.APP_PATH + "purchase");
            return null;
        }

        if (!authCheck() || email == null) {
            purchaseData.maxStep = 1;
            sessionStorage.setItem('ls.purchase', JSON.stringify(purchaseData));
            history.push("/" + GlobalConstants.APP_PATH + "purchase/subscription/authenticate");
            return null;
        } else if (queryParams.get("error") != null) {
            setErrorMessage(Strings.PURCHASE_CONFIRMATION_UNKNOWN_ERROR);
        } else if (queryParams.get("paymentFinished") != null && queryParams.get("paymentFinished") === "1") {
            //Finalize the payment
            const onFinalizeSuccess = () => {
                gtmw.purchaseEvent(purchaseData);
                setTimeout(() => {
                    console.log("Wait 2 seconds before redirecting");
                }, 1500);

                if (purchaseData.selectedColor) {
                    window.location.href = "https://info.tiger.media/dein-kauf-war-erfolgreich/";
                } else {
                    window.location.href = "https://tiger.media/pages/vielen-dank-fur-deinen-kauf";
                }
            };

            const onError = (...args) => {
                SendTeamsNotification("finalize", purchaseData.orderId, purchaseData.planVariantId, args).then(r => r);
                setPaymentError(true);
            }
            billwerkJSWrapper.finalize(onFinalizeSuccess, onError);

            return null;
        }

        if (purchaseData == null) {
            history.push("/" + GlobalConstants.APP_PATH + "purchase");
            return null;
        }

        const loadSubscriptionContracts = async () => {
            setLoading(true);
            let c = await GetFilteredResources('api/purchases/customer/contracts', {subscriptionsOnly: true}, 'application/json', GlobalConstants.SPINE_HOST);
            setLoading(false);
            if (c.error || c.result == null) {
                history.push("/" + GlobalConstants.APP_PATH + "purchase/error?code=5");
                return;
            }

            return c.result;
        }

        const previewOrder = async () => {

            //Create the request for the purchase service
            if (!purchaseData || !purchaseData.planVariantId) {
                return;
            }
            let request = {
                planVariantId: purchaseData.planVariantId,
                Cart: {
                    PlanVariantId: purchaseData.planVariantId,
                    MeteredUsages: (!purchaseData.selectedColor ? [] : [{
                        ComponentId: purchaseData.componentId,
                        Quantity: 1,
                        Memo: purchaseData.selectedGtin,
                        Key: "BOX_WITH_COLOR"
                    }]),
                    DiscountSubscriptions: (!purchaseData.discountId ? [] : [{
                        DiscountId: purchaseData.discountId
                    }])
                },
                Customer: {
                    EmailAddress: email.email,
                    FirstName: purchaseData.contact.firstName,
                    LastName: purchaseData.contact.lastName,
                    Address: {
                        Street: purchaseData.contact.street,
                        HouseNumber: purchaseData.contact.houseNumber,
                        PostalCode: purchaseData.contact.zip,
                        City: purchaseData.contact.city,
                        Country: purchaseData.contact.country
                    }
                }
            }

            let response = await CreateResource('api/purchases/billwerk/order/preview', request, true, GlobalConstants.SPINE_HOST);
            if (response.error) {
                if (response.result == null) {
                    setErrorMessage(Strings.PURCHASE_CONFIRMATION_UNKNOWN_ERROR);
                } else if (response.result.errorCode != null && Number(response.result.errorCode) === 24) {
                    setErrorMessage(Strings.PURCHASE_CONFIRMATION_ACTIVE_SUBSCRIPTION_ERROR.replace("{0}", email.email));
                } else if (response.result.errorCode != null && (Number(response.result.errorCode) === 51 || Number(response.result.errorCode) === 52)) {
                    setErrorMessage(Strings.PURCHASE_CONFIRMATION_PLAN_NOT_ALLOWED);
                } else if (response.result.errorCode != null && Number(response.result.errorCode) === 53) {
                    setErrorMessage(Strings.EMAIL_CONFIRMATION_REQUIRED);
                } else {
                    setErrorMessage(Strings.PURCHASE_CONFIRMATION_UNKNOWN_ERROR);
                }
                return;
            }
            return response;
        }

        function extractUsedComponentFromPreview(order, componentId) {
            order.MeteredComponents.forEach((component) => {
                if (component.ComponentId === componentId) {
                    setComponent(component)
                }
            });
        }

        function getDiscountDetails(order, discountId, priceData) {
            order.DiscountSubscriptions.forEach((discount) => {
                if (discount.DiscountId === discountId) {
                    GetResource('api/purchases/billwerk/discounts/' + discountId, 'application/json', {}, GlobalConstants.SPINE_HOST)
                        .then(response => {
                            if (!response.error) {
                                let discount = response.result;
                                setDiscount(discount);
                                let discountedBrutto = (priceData.brutto - (priceData.brutto * discount.Effect.ReductionPercent / 100)).toFixed(2);
                                let discountedNetto = (priceData.discountedBrutto / (1 + priceData.tax)).toFixed(2);
                                let discountedTaxAmount = (priceData.discountedBrutto - priceData.discountedNetto).toFixed(2);
                                setPriceData(prevData => ({
                                        ...prevData,
                                        discountedBrutto: discountedBrutto,
                                        discountedNetto: discountedNetto,
                                        discountedTaxAmount: discountedTaxAmount
                                    })
                                )
                            }
                        });
                }
            });
        }

        function getTrialInformation(orderPreview) {
            if (orderPreview != null && orderPreview.TrialPeriod != null) {
                const unit = orderPreview.TrialPeriod.unit;
                const quantity = orderPreview.TrialPeriod.quantity;

                const d = new Date(orderPreview.RecurringFee.LineItems[0].PeriodStart);

                //Calculate the new date
                if (unit === 'day') {
                    d.setDate(d.getDate() + quantity);
                } else if (unit === 'week') {
                    d.setDate(d.getDate() + 7 * quantity);
                } else if (unit === 'month') {
                    d.setDate(d.getDate() + 31 * quantity);
                } else if (unit === 'year') {
                    d.setDate(d.getDate() + 365 * quantity);
                }

                let trialUnitName;
                if (unit === 'day') {
                    trialUnitName = Strings.PURCHASE_CONFIRMATION_PERIOD_PER_DAY;
                } else if (unit === 'week') {
                    trialUnitName = Strings.PURCHASE_CONFIRMATION_PERIOD_PER_WEEK;
                } else if (unit === 'month') {
                    trialUnitName = Strings.PURCHASE_CONFIRMATION_PERIOD_PER_MONTH;
                } else if (unit === 'year') {
                    trialUnitName = Strings.PURCHASE_CONFIRMATION_PERIOD_PER_YEAR;
                }

                return {
                    trialDate: transformStringToReadableDate(d.toISOString()),
                    trialDuration: quantity,
                    trialUnit: unit,
                    trialUnitName: trialUnitName
                };
            }
            return null;
        }

        const loadPremiumAccessFeature = async (planVariantId) => {
            setLoading(true);
            let p = await GetResource('api/premiumAccessFeatures/search/by-planVariantId?planVariantId=' + planVariantId,
                'application/json', {}, GlobalConstants.SPINE_HOST);
            setLoading(false);
            if (p.error || p.result == null) {
                return null;
            }
            return p.result;
        }

        function analysePremiumAccessFeature(r) {
            setPremiumAccessFeature(r);
            dataRef.current = r._embedded.planVariant.RecurringFee;
            if (r._embedded.planVariant.NextPlanVariantId) {
                loadPremiumAccessFeature(r._embedded.planVariant.NextPlanVariantId).then(r => {
                    setNextPlanVariant(r);
                    if (r._embedded.planVariant.BillingPeriod.unit === "month") {
                        setFeePeriodUnitName(Strings.PURCHASE_CONFIRMATION_BUNDLE_PER_MONTH_SMALL);
                    } else {
                        setFeePeriodUnitName(Strings.PURCHASE_CONFIRMATION_BUNDLE_PER_YEAR_SMALL);
                    }
                });
            } else {
                setNextPlanVariant(r);
                if (r._embedded.planVariant.BillingPeriod.unit === "month") {
                    setFeePeriodUnitName(Strings.PURCHASE_CONFIRMATION_BUNDLE_PER_MONTH_SMALL);
                } else {
                    setFeePeriodUnitName(Strings.PURCHASE_CONFIRMATION_BUNDLE_PER_YEAR_SMALL);
                }
            }
        }

        if (!purchaseData.premiumAccessFeature) {
            loadPremiumAccessFeature(purchaseData.planVariantId).then(r => {
                analysePremiumAccessFeature(r);
            });
        } else {
            analysePremiumAccessFeature(purchaseData.premiumAccessFeature);
        }

        previewOrder().then(r => {
            if (!r.error) {
                let preview = r.result;
                setOrderPreview(preview);

                if (preview?.TotalGross != null && preview?.TotalGross !== 0) {
                    if (preview?.RecurringFee?.LineItems[0]?.PeriodStart) {
                        setFirstPaymentDate(transformStringToReadableDate(preview.RecurringFee.LineItems[0].PeriodStart));
                    }
                } else {
                    //handle follow up contracts (downgrades)
                    if (preview?.NextTotalGross != null && preview?.NextTotalGross !== 0) {
                        if (preview?.NextTotalGrossDate) {
                            setFirstPaymentDate(getFirstPaymentDateFromPhases(preview));
                        }
                    }
                }

                let priceData = calculatePrices(dataRef.current, purchaseData)
                setPriceData(priceData);

                let trialInformation = getTrialInformation(preview);
                setTrialInformation(trialInformation);

                if (purchaseData.selectedColor) {
                    extractUsedComponentFromPreview(r.result, purchaseData.componentId);
                }
                if (purchaseData.discountId) {
                    getDiscountDetails(preview, purchaseData.discountId, priceData);
                }

                replacePointWithCommaInPrices(priceData);
            }
        });

        //check if customer has already a trial period has used, in this case we don't offer another one
        loadSubscriptionContracts().then(r => {
            let trial = true;
            if (Array.isArray(r)) {
                for (let i = 0; i < r.length; i++) {
                    let phases = r[i].Phases;
                    if (phases != null && Array.isArray(phases) && phases.length > 0) {
                        for (let j = 0; j < phases.length; j++) {
                            if (phases[j].Type != null && phases[j].Type === "Trial") {
                                trial = false;
                            }
                        }
                    }
                }
            }
            setHasTrial(trial);
        })
    }, [history]);

    if (new URLSearchParams(window.location.search).get("paymentFinished") === "1") {
        //Finalize the payment
        let purchaseData = JSON.parse(sessionStorage.getItem('ls.purchase')) != null ?
            JSON.parse(sessionStorage.getItem('ls.purchase')) : {payment: {channelSecrets: {}}, contact: {}};
        const onSuccess = () => {
            //add purchase event ?
            if (purchaseData.selectedColor) {
                window.location.href = "https://info.tiger.media/dein-kauf-war-erfolgreich/";
            } else {
                window.location.href = "https://tiger.media/pages/vielen-dank-fur-deinen-kauf";
            }
        };
        const onError = (...args) => {
            SendTeamsNotification("finalize", purchaseData.orderId, purchaseData.planVariantId, args).then(r => r);
            setPaymentError(true);
        }
        billwerkJSWrapper.finalize(onSuccess, onError);
        return null;
    }

    const submitOrder = async (e) => {
        e.preventDefault();
        setLoading(true);

        //Create the request for the purchase service
        if (!orderDataIsValid()) {
            return;
        }
        let request = {
            Cart: {
                PlanVariantId: purchaseData.planVariantId,
                MeteredUsages: (!purchaseData.selectedColor ? [] : [{
                    ComponentId: purchaseData.componentId,
                    Quantity: 1,
                    Memo: purchaseData.selectedGtin
                }]),
                DiscountSubscriptions: (!purchaseData.discountId ? [] : [{
                    DiscountId: purchaseData.discountId
                }])
            },
            Customer: {
                EmailAddress: email.email,
                FirstName: purchaseData.contact.firstName,
                LastName: purchaseData.contact.lastName,
                Address: {
                    Street: purchaseData.contact.street,
                    HouseNumber: purchaseData.contact.houseNumber,
                    PostalCode: purchaseData.contact.zip,
                    City: purchaseData.contact.city,
                    Country: purchaseData.contact.country
                }
            }
        }

        let response = await CreateResource('api/purchases/billwerk/order/submit', request, true, GlobalConstants.SPINE_HOST);
        if (response.error) {
            if (response.result == null) {
                setErrorMessage(Strings.PURCHASE_CONFIRMATION_UNKNOWN_ERROR);
            } else if (response.result.errorCode != null && Number(response.result.errorCode) === 24) {
                setErrorMessage(Strings.PURCHASE_CONFIRMATION_ACTIVE_SUBSCRIPTION_ERROR.replace("{0}", email.email));
            } else if (response.result.errorCode != null && (Number(response.result.errorCode) === 51 || Number(response.result.errorCode) === 52)) {
                setErrorMessage(Strings.PURCHASE_CONFIRMATION_PLAN_NOT_ALLOWED);
            } else if (response.result.errorCode != null && Number(response.result.errorCode) === 53) {
                setErrorMessage(Strings.EMAIL_CONFIRMATION_REQUIRED);
            } else {
                setErrorMessage(Strings.PURCHASE_CONFIRMATION_UNKNOWN_ERROR);
            }
            setLoading(false);
            return;
        }
        let order = response.result;
        let value = 0;
        if (purchaseData.selectedColor) {
            if (component) {
                value += component.PricePerUnit;
            }
        }
        value = premiumAccessFeature._embedded.planVariant.BillingPeriod.quantity * premiumAccessFeature._embedded.planVariant.RecurringFee;
        if (discount) {
            let discountValue = discount.Duration.quantity * (priceData.brutto - priceData.discountedBrutto)
            value -= discountValue;
        }
        value = Math.round(value * 100) / 100;

        let billwerkOrder = {OrderId: order.orderId, Currency: order.currency};
        purchaseData.orderId = order.orderId;
        purchaseData.value = value;
        purchaseData.currency = order.currency;
        sessionStorage.setItem('ls.purchase', JSON.stringify(purchaseData));

        //Billwerk pay request
        if (!purchaseDataIsValid()) {
            return;
        }
        let paymentData = {};
        if (purchaseData.paymentMethod === GlobalConstants.PAYMENT_METHOD_DEBIT) {
            paymentData = {
                bearer: 'Debit:Mollie',
                accountHolder: purchaseData.paymentData.accountHolder.trim(),
                iban: purchaseData.paymentData.iban.replace(/\s/g, ""),
                bic: purchaseData.paymentData.bic.replace(/\s/g, "")
            }
        } else if (purchaseData.paymentMethod === GlobalConstants.PAYMENT_METHOD_CREDIT_CARD) {
            paymentData = {
                bearer: 'CreditCard:Mollie',
            }
        } else if (purchaseData.paymentMethod === GlobalConstants.PAYMENT_METHOD_PAYPAL) {
            paymentData = {
                bearer: 'PayPal:Reepay',
            }
        }

        const onError = (data) => {
            SendTeamsNotification("paySignupInteractive", purchaseData.orderId, purchaseData.planVariantId, data).then(r => r);
            setLoading(false);
            history.push("/" + GlobalConstants.APP_PATH + "purchase/subscription/confirmation");
            setPaymentErrorMessage(data.errorMessage);
            setPaymentError(true);
        }

        const onSuccess = (data) => {
            gtmw.purchaseEvent(purchaseData);
            setTimeout(() => {
                console.log("Wait 2 seconds before redirecting");
            }, 1500);

            const url2fa = data.Url;
            if (url2fa) {
                window.location.href = url2fa;
            } else {
                if (purchaseData.selectedColor) {
                    window.location.href = "https://info.tiger.media/dein-kauf-war-erfolgreich/";
                } else {
                    window.location.href = "https://tiger.media/pages/vielen-dank-fur-deinen-kauf";
                }
            }
        }
        billwerkJSWrapper.paySignupInteractive(paymentData, billwerkOrder, onSuccess, onError);
    }

    const purchaseDataIsValid = () => {
        if (purchaseData.paymentMethod === GlobalConstants.PAYMENT_METHOD_DEBIT) {
            if (purchaseData.paymentData == null) {
                setErrorMessage(Strings.PURCHASE_CONFIRMATION_VALIDATION_ERROR.replace("{0}", "10"));
                return false;
            } else if (purchaseData.paymentData.accountHolder == null || purchaseData.paymentData.iban == null || purchaseData.paymentData.bic == null) {
                setErrorMessage(Strings.PURCHASE_CONFIRMATION_VALIDATION_ERROR.replace("{0}", "11"));
                return false;
            }
        }
        return true;
    }

    const orderDataIsValid = () => {
        if (purchaseData == null) {
            //Purchase data is not set
            setErrorMessage(Strings.PURCHASE_CONFIRMATION_VALIDATION_ERROR.replace("{0}", "7"));
            return false;
        } else if (purchaseData.planVariantId == null) {
            setErrorMessage(Strings.PURCHASE_CONFIRMATION_VALIDATION_ERROR.replace("{0}", "8"));
            return false;
        } else if (purchaseData.contact == null) {
            setErrorMessage(Strings.PURCHASE_CONFIRMATION_VALIDATION_ERROR.replace("{0}", "9"));
            return false;
        }
        return true;
    }

    function calculatePrices(price, purchaseData) {
        //Default
        let tax = 0.19;
        let unit = "€";
        if (purchaseData != null && purchaseData.contact != null && purchaseData.contact.country != null) {
            if (purchaseData.contact.country === "DE") {
                tax = Number(GlobalConstants.TAX_DE);
            } else if (purchaseData.contact.country === "AT") {
                tax = Number(GlobalConstants.TAX_AT);
            } else if (purchaseData.contact.country === "CH") {
                tax = Number(GlobalConstants.TAX_CH);
                unit = "CHF";
            }
        }

        //Calculation and formatting
        let brutto = (price).toFixed(2);
        let netto = (price / (1 + tax)).toFixed(2);
        let taxAmount = (brutto - netto).toFixed(2);

        return {brutto: brutto, tax: taxAmount, netto: netto, unit: unit}
    }

    const getPaymentMethodName = (method) => {
        switch (method) {
            case GlobalConstants.PAYMENT_METHOD_CREDIT_CARD:
                return Strings.PURCHASE_PAYMENT_METHOD_CC;
            case GlobalConstants.PAYMENT_METHOD_PAYPAL:
                return Strings.PURCHASE_TICKET_PAYMENT_METHOD_PAYPAL;
            default:
                return Strings.PURCHASE_SUBSCRIPTION_PAYMENT_METHOD_DEBIT;
        }
    }

    const onChangeStep = (step) => {
        switch (step) {
            case 0:
                history.push("/" + GlobalConstants.APP_PATH + "bundles/colors?planVariantId=" + purchaseData.planVariantId + "&componentId=" + purchaseData.componentId + (purchaseData.discountId ? "&discountId=" + purchaseData.discountId : ''));
                return;
            case 1:
                setShowLoginHint(true);
                return;
            case 2:
                history.push("/" + GlobalConstants.APP_PATH + "purchase/subscription/payment");
                return;
            case 3:
                //Active step -> Do nothing
                return;
            case 4:
                if (purchaseData.maxStep > 3) {
                    history.push("/" + GlobalConstants.APP_PATH + "purchase/subscription/confirmation");
                }
                return;
            default:
                return;
        }
    }

    function replacePLaceholders(description) {
        if (description) {
            description = description.replace(`{color}`, purchaseData.selectedColor);
        }
        return description;
    }

    function getFirstPaymentDateFromPhases(preview) {
        let phases = preview.Contract.Phases;
        for (let i = 0; i < phases.length; i++) {
            if (phases[i].Type === 'Normal' && phases[i].PlanVariantId === preview.PlanVariantId) {
                return transformStringToReadableDate(phases[i].StartDate);
            }
        }
    }

    function replacePointWithCommaInPrices(priceData) {
        if (priceData) {
            setPriceData(prevData => ({
                    ...prevData,
                    brutto: priceData.brutto?.toString().replace('.', ','),
                    netto: priceData.netto?.toString().replace('.', ','),
                    discountedBrutto: priceData.discountedBrutto?.toString().replace('.', ','),
                    discountedNetto: priceData.discountedNetto?.toString().replace('.', ','),
                    discountedTaxAmount: priceData.discountedTaxAmount?.toString().replace('.', ','),
                })
            )
        }
    }

    if (loading) {
        return <TigerSpinner/>
    }

    const editPaymentData = () => history.push("/" + GlobalConstants.APP_PATH + "purchase/subscription/payment");

    return (
        <>
            {purchaseData &&
                <div className="purchase-container">
                    <PurchaseStatus step={3} maxStep={purchaseData ? purchaseData.maxStep : 1}
                                    bundled={!!purchaseData?.selectedColor}
                                    onChangeStep={(step) => onChangeStep(step)}
                    />
                    <div className="purchase-page">
                        <h1 className="purchase-page-title">{Strings.PURCHASE_CONFIRMATION_TITLE}</h1>
                        <div className="purchase-page-info"
                             dangerouslySetInnerHTML={{__html: Strings.PURCHASE_CONFIRMATION_INFO}}/>

                        {/*Kombipakete werden derzeit nicht verwendet*/}
                        {purchaseData?.selectedColor &&
                            <>
                                <div className="purchase-page-section-label">
                                    {Strings.PURCHASE_CONFIRMATION_BUNDLE_NAME} {discount && ' – ' + discount.InternalName}
                                </div>
                                <div className="purchase-page-box">
                                    {/* the following part comes from database */}
                                    <ul className="purchase-confirmation-list" style={{marginBottom: 0}}
                                        dangerouslySetInnerHTML={{__html: replacePLaceholders(premiumAccessFeature?.checkoutDescription)}}/>

                                    {trialInformation &&
                                        <ul className="purchase-confirmation-list">
                                            <li>{Strings.PURCHASE_SUBSCRIPTION_CONFIRMATION_PRODUCT_TRIAL_PERIOD
                                                .replace("{0}", trialInformation.trialDuration)
                                                .replace("{1}", trialInformation.trialUnitName)
                                                .replace("{2}", trialInformation.trialDate)}
                                            </li>
                                        </ul>
                                    }
                                    {orderPreview && component && priceData &&
                                        <div className="purchase-page-summary-row total">
                                            <span>{Strings.PURCHASE_CONFIRMATION_BUNDLE_SETUP_FEE}</span>
                                            <span className="purchase-page-summary-price">{priceData?.brutto + " " + orderPreview?.Currency}</span>
                                        </div>
                                    }
                                    {discount &&
                                        <div className="purchase-page-summary-row total">
                                            <span>
                                                {trialInformation && trialInformation.trialUnit === 'month' ?
                                                    Strings.PURCHASE_CONFIRMATION_DISCOUNTED_PER_MONTH_WITH_TRIAL
                                                        .replace("{0}", trialInformation.trialDuration + 1)
                                                        .replace("{1}", trialInformation.trialDuration + discount.Duration.quantity)
                                                    :
                                                    (orderPreview && orderPreview.RecurringFee && orderPreview.RecurringFee.FeePeriod && orderPreview.RecurringFee.FeePeriod.unit === 'month' ?
                                                            Strings.PURCHASE_CONFIRMATION_DISCOUNTED_PER_MONTH.replace("{0}", discount.Duration.quantity)
                                                            :
                                                            Strings.PURCHASE_CONFIRMATION_DISCOUNTED_PER_YEAR
                                                    )
                                                }
                                            </span>
                                            <span className="purchase-page-summary-price">{priceData?.brutto + " " + orderPreview?.Currency}</span>
                                        </div>
                                    }
                                    <div className="purchase-page-summary-row total">
                                        <span>{(discount ? Strings.PURCHASE_CONFIRMATION_DISCOUNTED : "") + feePeriodUnitName}</span>
                                        <span className="purchase-page-summary-price">
                                            {nextPlanVariant?._embedded?.planVariant?.RecurringFee + " " + nextPlanVariant?._embedded?.planGroup?.Currency}
                                        </span>
                                    </div>
                                </div>
                            </>
                        }
                        {!purchaseData.selectedColor &&
                            <>
                                <div className="purchase-page-section-label">{Strings.PURCHASE_CONFIRMATION_SUBSCRIPTION}</div>
                                <div className="purchase-page-box">
                                    <div
                                        dangerouslySetInnerHTML={{__html: Strings.PURCHASE_TARIF_CHOSEN_TARIF.replace(
                                            "{0}",
                                            premiumAccessFeature?.checkoutProductName ?? ""
                                        )}}
                                    />
                                    <div
                                        dangerouslySetInnerHTML={{
                                            __html: premiumAccessFeature?.checkoutDescription ?? ""
                                        }}
                                    />
                                    {discount &&
                                        <>
                                            <div className="purchase-page-summary-row total">
                                                <span>
                                                    {discount?.Duration?.unit === 'month' ?
                                                        Strings.PURCHASE_CONFIRMATION_DISCOUNTED_PER_MONTH.replace("{0}", discount.Duration.quantity)
                                                        :
                                                        Strings.PURCHASE_CONFIRMATION_DISCOUNTED_PER_YEAR
                                                    }
                                                </span>
                                                <span className="purchase-page-summary-price">
                                                    {(discount ? priceData?.discountedBrutto : priceData?.brutto) + " " + orderPreview?.Currency}
                                                </span>
                                            </div>
                                            <div className="purchase-page-summary-row">
                                                <span>
                                                    {discount?.Duration?.unit === 'month' ?
                                                        Strings.PURCHASE_CONFIRMATION_DISCOUNTED + feePeriodUnitName
                                                        : Strings.PURCHASE_CONFIRMATION_DISCOUNTED_YEAR}
                                                    <span className="purchase-page-summary-note">
                                                        {Strings.PURCHASE_CONFIRMATION_DISCOUNTED_CANCEL_TEXT}
                                                    </span>
                                                </span>
                                                <span className="purchase-page-summary-price">
                                                    {nextPlanVariant?._embedded?.planVariant?.RecurringFee}{" "}
                                                    {nextPlanVariant?._embedded?.planGroup?.Currency}
                                                </span>
                                            </div>
                                        </>
                                    }
                                    <div className="purchase-page-summary-row total">
                                        <span>
                                            {trialInformation && hasTrial ?
                                                Strings.PURCHASE_SUBSCRIPTION_CONFIRMATION_PRODUCT_TRIAL_PERIOD
                                                    .replace("{0}", trialInformation.trialDuration)
                                                    .replace("{1}", trialInformation.trialUnitName)
                                                :
                                                Strings.PURCHASE_SUBSCRIPTION_FIRST_PAYMENT.replace("{0}", firstPaymentDate)
                                            }
                                        </span>
                                        <span className="purchase-page-summary-price">
                                            {(discount ? priceData?.discountedBrutto : priceData?.brutto) + " " + orderPreview?.Currency}
                                        </span>
                                    </div>
                                </div>
                            </>
                        }

                        <div className="purchase-page-section-label">{Strings.PURCHASE_CONFIRMATION_ACCOUNT}</div>
                        <div className="purchase-page-box">{email.email}</div>

                        <div className="purchase-page-section-header">
                            <div className="purchase-page-section-label">{Strings.PURCHASE_CONFIRMATION_PAYMENT_METHOD}</div>
                            <button type="button" className="purchase-page-link" onClick={editPaymentData}>
                                {Strings.PURCHASE_CONFIRMATION_EDIT}
                            </button>
                        </div>
                        <div className="purchase-page-box">{getPaymentMethodName(purchaseData.paymentMethod)}</div>

                        <div className="purchase-page-section-header">
                            <div className="purchase-page-section-label">
                                {purchaseData.selectedColor ? Strings.PURCHASE_DATA_ADDRESS_LABEL_BUNDLE : Strings.PURCHASE_CONFIRMATION_INVOICE}
                            </div>
                            <button type="button" className="purchase-page-link" onClick={editPaymentData}>
                                {Strings.PURCHASE_CONFIRMATION_EDIT}
                            </button>
                        </div>
                        <div className="purchase-page-box">
                            <div>{purchaseData.contact.firstName + " " + purchaseData.contact.lastName}</div>
                            <div>{purchaseData.contact.street + " " + purchaseData.contact.houseNumber}</div>
                            <div>{purchaseData.contact.zip + " " + purchaseData.contact.city}</div>
                            <div>{purchaseData.contact.country === "DE" ? Strings.PURCHASE_COUNTRY_DE :
                                (purchaseData.contact.country === "AT" ? Strings.PURCHASE_COUNTRY_AT : Strings.PURCHASE_COUNTRY_CH)}</div>
                        </div>

                        <label className="purchase-page-checkbox">
                            <input name="agb" id="agb" type="checkbox" checked={agb} onChange={() => setAgb(!agb)}/>
                            <span dangerouslySetInnerHTML={{__html: purchaseData.selectedColor ? Strings.PURCHASE_CONFIRMATION_BUNDLE_AGB : Strings.PURCHASE_CONFIRMATION_AGB}}/>
                        </label>

                        <button type="button" className="purchase-page-button" onClick={(e) => submitOrder(e)} disabled={!agb}>
                            {loading ? <Spinner animation="border" size="sm"/> : Strings.PURCHASE_CONFIRMATION_SUBMIT_BUTTON}
                        </button>
                    </div>

                    <InfoModal
                        title={Strings.REGISTER_UNKNOWN_ERROR_TITLE}
                        text={errorMessage}
                        extraContent={errorMessage === Strings.EMAIL_CONFIRMATION_REQUIRED ? <ResendActivationMail/> : null}
                        show={errorMessage != null}
                        onHide={() => setErrorMessage(null)}/>

                    <InfoModal
                        title={Strings.PURCHASE_PAYMENT_ERROR_TITLE}
                        text={paymentErrorMessage ? paymentErrorMessage : Strings.PURCHASE_PAYMENT_ERROR_BODY}
                        show={paymentError}
                        onHide={() => setPaymentError(false)}/>

                    <InfoModal
                        title={Strings.PURCHASE_TARIF_NOT_ALLOWED}
                        text={errorMessage}
                        extraContent={errorMessage === Strings.EMAIL_CONFIRMATION_REQUIRED ? <ResendActivationMail/> : null}
                        show={errorMessage != null}
                        closeButtonLabel={"Anderen Tarif wählen!"}
                        closeButtonVariant="danger"
                        onHide={() => {
                            setPaymentError(false)
                            history.push("/" + GlobalConstants.APP_PATH + "premium")
                        }}/>

                    <ConfirmationModal
                        title={Strings.PURCHASE_REAUTHENTICATE_TITLE}
                        text={Strings.PURCHASE_REAUTHENTICATE_HINT}
                        actionButtonLabel={Strings.PURCHASE_REAUTHENTICATE_BUTTON}
                        actionButtonVariant="danger"
                        onActionPress={() => {
                            localStorage.removeItem("ls.token");
                            sessionStorage.removeItem("ls.purchase");
                            history.push("/" + GlobalConstants.APP_PATH + "purchase/" + purchaseData.planVariantId + '?selectedColor=' + (purchaseData.selectedColor ? purchaseData.selectedColor : '') + "&componentId=" + (purchaseData.componentId ? purchaseData.componentId : '') + (purchaseData.discountId ? "&discountId=" + purchaseData.discountId : '') + (purchaseData.selectedGtin ? "&selectedGtin=" + purchaseData.selectedGtin : ''))
                        }}
                        show={showLoginHint}
                        onHide={() => setShowLoginHint(false)}
                    />
                </div>
            }
        </>
    )
}
